import {
  getPlatformLogo,
  getPlatformName,
  type SOURCE_PLATFORM_TYPE,
} from '@/entities/public-filter/constants';
import { Card, CardContent, CardHeader, CardTitle } from '@/shared/components/shadcn/card';
import { Skeleton } from '@/shared/components/shadcn/skeleton';
import { ToggleStage } from '@/shared/components/stage/toggle-stage';
import { formatNumber } from '@/shared/utils/format-number';

export const StatCard = ({
  title,
  value,
  platformStatistic,
  isLoading,
}: {
  title: string;
  value: number;
  platformStatistic: { platform: SOURCE_PLATFORM_TYPE; value: number }[];
  isLoading?: boolean;
}) => {
  return (
    <Card className="gap-0 border border-zinc-200 bg-white dark:border-zinc-700 dark:bg-zinc-800">
      <CardHeader className="mb-1.5 gap-0">
        <CardTitle className="text-base-muted-foreground text-sm font-normal">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <ToggleStage
          className="flex flex-col gap-3"
          fallback={
            <>
              <Skeleton className="mb-4 h-6 w-33" />
              <Skeleton className="h-4" />
              <Skeleton className="h-4" />
            </>
          }
          status={!isLoading}
        >
          <div className="text-base-card-foreground text-2xl font-bold">{formatNumber(value)}</div>
          <div className="flex flex-col gap-1.5">
            {platformStatistic.map(({ platform, value }) => {
              const PlatformLogo = getPlatformLogo(platform);
              const platformName = getPlatformName(platform);
              return (
                <div key={platform.toString()} className="flex items-center justify-between gap-1">
                  <div className="flex items-center gap-2">
                    <PlatformLogo className="size-3.5" />
                    <span className="text-base-card-foreground text-sm font-normal">
                      {platformName}
                    </span>
                  </div>
                  <span className="text-sm font-medium">{formatNumber(value)}</span>
                </div>
              );
            })}
          </div>
        </ToggleStage>
      </CardContent>
    </Card>
  );
};
